<template>
	<div class="container">
		<div class="HeaderTop">
            <img class="LogoImg" src="/static/logoSystemBai.png?v=2" alt="" />
			<div class="UserInfo">
                <div class="HeadTopNav">
                    <el-button v-throttle type="primary" size="small" v-if="SystemBlon" @click="SeleUser('system')">切换系统</el-button>
                    <el-button v-throttle type="primary" size="small" v-if="!AdminType" @click="SeleUser('cer')">个人中心</el-button>
                    <el-button v-throttle type="primary" size="small" v-if="SystemName == '评审专家' && Menu.some(item => item.path === '/ExpertScene')"  @click="SeleUser('Mobile')">移动端</el-button>
                    <div v-if="$Tools.localData('g')" class="UserName">管理员</div>
                    <div v-else class="UserName">{{SystemName}}</div>
                </div>
				<el-dropdown trigger="click" @command="SeleUser">
                  <div class="UserDis">
                      <div class="UserName">
                          {{Data.nickname||Data.name}} <i class="el-icon-arrow-down"></i>
                      </div>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <!-- <el-dropdown-item icon="el-icon-mobile-phone" command="Mobile" v-if="SystemName == '评审专家'">移动端</el-dropdown-item> -->
                    <!-- <el-dropdown-item icon="el-icon-monitor" command="system" v-if="SystemBlon">切换系统</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-s-custom" command="cer" v-if="!AdminType">个人中心</el-dropdown-item> -->
                    <el-dropdown-item icon="el-icon-switch-button" command="out">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
			</div>
		</div>
		<div class="HeaderCont">
			<aside class="NavS">
                <div class="NavSItem" :class="{Act:item.path == $route.path}" v-for="item in Menu" :key="item.path" @click="goPage(item)">
                    <i v-if="item.icon.startsWith('el-')" :class="item.icon"></i>
                    <i v-else class="iconfont" :class="item.icon"></i>
                    <div class="NavSItemName">{{item.title}}</div>
                </div>
			</aside>
			<section class="HeaderPage">
                <!-- <div class="PageName">{{PageName||$route.name}}</div> -->
                <div>
                    <transition name="fade" mode="out-in">
                        <router-view></router-view>
                    </transition>
                </div>
			</section>
		</div>
        <el-dialog title="移动端" :visible.sync="MobileBlon" width="20%">
            <div class="QRcodeHead">
                <img class="QRcodeImg" :src="MobileCode" alt="" />
            </div>
        </el-dialog>
        <el-dialog title="保密协议" :visible.sync="ExpertBlon" width="80%" :modal-append-to-body="false" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <div class="QRcodeHead MaxHei" v-html="ExpertCont"></div>
            <div slot="footer">
                <div class="footer">
                    <el-button v-throttle class="BgColor" size="small" type="primary" @click="GetExpertCode">同意并签名</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="签名" :visible.sync="QRcodeBlon" width="20%" :modal-append-to-body="false" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <div class="QRcodeHead">
                <img class="QRcodeImg" :src="QRcode" alt="" />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-throttle size="small" type="primary" @click="SucQRcode">我已签名</el-button>
              </span>
        </el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
                PageName:"",
                System:"",
                SystemName:"",
                SystemBlon:false,
                Data:"",
                Menu:[],
                AdminType:false,
                MobileBlon:false,
                MobileCode:"",
                QRcodeBlon:false,
                QRcode:"",
                ExpertBlon:false,
                ExpertCont:"",
			}
		},
		mounted() {
            this.System = JSON.parse(sessionStorage.getItem("Nav"));
            this.AdminType = this.$Tools.localData('g')==1?true:false;
            if(this.System){
                var num = this.System.length==1?0:this.System.length;
                this.System.forEach(item=>{
                    num+=item.child.length;
                })
                this.SystemBlon = num>1?true:false;
            }
            if(this.AdminType){
                this.GetAdminMenu();
            }else{
                // this.Data = JSON.parse(sessionStorage.getItem('USER-Info')).user_info;
                if(sessionStorage.getItem('SYSTEM-TOKEN')=="expert_portal"){
                    this.SystemName = "评审专家";
                    this.GetExpertMenu();
                }else{
                    this.SystemName = JSON.parse(sessionStorage.getItem("SYSTEM-Data")).system_name;
                    //获取用户操作系统
                    this.GetSystemMenu();
                }
                if(this.$Tools.localData('ExpertNum')){
                    this.$alert('个人中心资料未完善，请前往完善', '提示', {
                        confirmButtonText: '前往',
                        callback: action => {
                            this.$Tools.localData('ExpertNum',null);
                            if(action == 'confirm'){
                                this.$router.push('/Center');
                            }
                        }
                    });
                }
            }
            this.GetInfo();
            this.GetCity();
            this.GetSystem();
             
		},
		methods: {
            GetInfo(){
                var url = this.AdminType?'/admin/auth/userInfo':'api/auth/userInfo';
                this.$get(url).then(res=>{
                    if(res){
                        this.Data = res.data;
                        this.$Tools.localData("UserId",res.data.id);
                        if(!this.Data.qm_url&&sessionStorage.getItem('SYSTEM-TOKEN')=="expert_portal"){
                            this.GetExpertXieYi();
                        }
                    }
                })
            },
            GetAdminMenu(){
                this.$get('/admin/auth/getRolesAndMenus').then(res=>{
                    if(res){
                        this.Menu = res.data.menus;
                        this.PageName = res.data.menus[0].title;
                    }
                })
            },
            GetSystem(){
                var url = this.AdminType?'/admin/system/getAll':'/api/auth/getAll';
                this.$get(url).then(res=>{
                    if(res){
                        this.$Tools.localData("SystemMenu",JSON.stringify(res.data));
                    }
                })
            },
            GetSystemMenu(){
                const routes = this.$router.options.routes;
                const homeRoute = routes.find(route => route.path === this.$route.matched[0].path);
                    if (homeRoute && homeRoute.children) {
                        this.Menu = homeRoute.children.map(i=>{
                          return {
                              title:i.name,
                              path:i.path,
                              icon:i.icon
                          }
                      })
                  }
            },
            GetExpertMenu(){
                this.$get('/api/expert_portal/systemlist').then(res=>{
                    if(res){
                        this.Menu = res.data.list[0].cd_list;
                        this.PageName = res.data.list[0].cd_list[0].title;
                        this.$Tools.localData("ThisMenu",JSON.stringify(res.data.list));
                    }
                })
            },
            GetExpertXieYi(){
                this.$get('/api/expert_portal/xieyi').then(res=>{
                    if(res){
                        this.ExpertCont = res.data.content;
                        this.ExpertBlon = true;
                    }
                })
            },
            GetExpertCode(){
                this.$get('/api/expert_portal/xieyiqrcodes').then(res=>{
                    if(res){
                        this.QRcode = res.data.base64;
                        this.QRcodeBlon = true;
                    }
                })
            },
            SetExpertMenu(data){
                this.Menu = data;
            },
            GetCity(){
                this.$get('/common/area/tree',{
                }).then(res=>{
                    if(res){
                       this.$Tools.localData("City",JSON.stringify(res.data))
                    }
                })
            },
			goPage(item){
                this.PageName = item.title;
                if(item.systems&&item.systems.length>0){
                    this.$Tools.localData("ThisMenu",JSON.stringify(item.systems));
                }
				this.$router.push(item.path);
			},
            SeleUser(type){
                if(type == "out"){this.logout()};
                if(type == "cer"){this.$router.push('/Center')};
                if(type == "system"){this.$router.push('/nav')};
                if(type == "Mobile"){
                    this.$get('api/expert_portal/qrcodes').then(res=>{
                        if(res){
                            this.MobileCode = res.data.base64;
                            this.MobileBlon = true;
                        }
                    })
                };
            },
            SucQRcode(){
                this.$get('api/expert_portal/xieyitj').then(res=>{
                    if(res){
                        this.QRcode = "";
                        this.QRcodeBlon = false;
                        this.ExpertCont = "";
                        this.ExpertBlon = false;
                    }
                })
            },
			logout(){
				var _this = this;
				this.$confirm('确认退出吗?', '提示', {
					type: 'warning'
				}).then(() => {
                    var Url = localStorage.getItem('g') ==1? '/admin/auth/logout':'api/auth/logout';
                    this.$post(Url).then(res=>{
                        if(res){
                            if(localStorage.getItem('g') ==1){
                                _this.$router.push('/AdminLogin');
                            }else{
                                _this.$router.push('/login');
                            }
                        }
                    })
				})
			},
		}
	}

</script>

<style scoped>
.container {
    background: #f6f6f6;
    height: 98vh; /* 添加高度限制 */
    display: flex;
    flex-direction: column;
    position: relative;
}
.HeaderTop {
    background: #095b95;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0; /* 防止顶部被压缩 */
}
.PosAbs{
    position: absolute;
    bottom: 10px;
    right: 10px;
}
.LogoImg {
    width: 400px;
}

.UserInfo {
    width: auto;
    display: flex;
    align-items: center;
}

.HeadTopNav {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-right: 10px;
    margin-right: 10px;
    border-right: 2px solid #fff;
    cursor: pointer;
}

.el-icon-s-home {
    color: #fff;
    font-size: 20px;
}

.UserDis {
    display: flex;
    align-items: center;
}

.UserImg {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
}

.UserName {
    color: #fff;
    cursor: pointer;
}

.UserName .el-icon-arrow-down {
    margin-left: 5px;
}

.HeaderCont {
    display: flex;
    flex: 1; /* 占据剩余空间 */
    overflow: hidden; /* 防止内容溢出 */
    min-height: 0; /* Flexbox 中的最小高度 */
}

.NavS {
    width: 200px;
    background: #fff;
    flex-shrink: 0; /* 防止侧边栏被压缩 */
    overflow-y: auto; /* 如果内容过多，添加滚动 */
}

.NavSItem {
    display: flex;
    align-items: center;
    padding: 15px;
    color: #4f4e4e;
}

.NavSItem:hover {
    background: #e8f3ff;
    color: #095b95;
    cursor: pointer;
}

.NavSItem.Act {
    background: #e8f3ff;
    color: #095b95;
}

.NavSItemName {
    margin-left: 5px;
    font-size: 15px;
    font-weight: 700;
}

.HeaderPage {
    margin-left: 20px;
    flex: 1; /* 占据剩余空间 */
    padding: 20px;
    background: #fff;
    overflow-y: auto; /* 内容过多时滚动 */
    min-width: 0; /* 防止 flex 布局中的宽度溢出 */
    /* background:url("../../static/1.png"); */
}

.PageName {
    font-weight: 700;
    padding-bottom: 20px;
    font-size: 19px;
    color: #454545;
}
.QRcodeHead{
    text-align: center;
}
.MaxHei{
    max-height: 50vh;
    overflow: auto;
}
.QRcodeImg{
    width: 200px;
    height: 200px;
    border-radius: 5px;
}

/* 过渡动画 */
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>